
import { Component } from 'react'
import { Col, Row } from 'reactstrap'
import TablePreferencePicker from '../../Material/TablePreferencePicker'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import CreateUpdateTPAConfigModal from '../Modals/CreateUpdateTPAConfigModal'


class TPAConfigAction extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
        }
    }

    toggleModal = (modalName) => {
        this.setState({ openModal: this.state.openModal === modalName ? "" : modalName })
    }

    render() {
        return (
            <Row>
                <Col xs={12} className="text-right mt-3">
                    <a id="toggleColumnPickerButton" className="driver-list-button" onClick={() => this.toggleModal("viewColumnPicker")}>
                        PREFERENCE | <i className="fa fa-table" aria-hidden="true"></i>
                    </a>&nbsp;&nbsp;&nbsp;
                    <a id="createNewTpaConfig" className="driver-list-button" onClick={() => this.toggleModal("createNewTpaConfig")}>
                        CREATE | <i className="fa fa-plus" aria-hidden="true"></i>
                    </a>&nbsp;&nbsp;&nbsp;
                    {this.state.openModal === "createNewTpaConfig" &&
                        <CreateUpdateTPAConfigModal
                            isOpen={this.state.openModal === "createNewTpaConfig"}
                            toggle={() => this.toggleModal("")}
                            refetchQuery={this.props.refetchQuery}
                        />}
                    {this.state.openModal === "viewColumnPicker" &&
                        <TablePreferencePicker
                            columnConfig={this.props.columnConfig}
                            currentUser={this.props.currentUser}
                            open={this.state.openModal === "viewColumnPicker"}
                            target="toggleColumnPickerButton"
                            setColumns={this.props.setColumns}
                            refetchPreferences={this.props.refetchPreferences}
                            preferenceType={"tpaconfig"}
                        />
                    }
                </Col>
            </Row>
        )
    }
}


export default (TPAConfigAction)